import { ServiceResponse } from '@sdbn/appclient';
import { PageCall } from 'src/tmc-common/model/terminal.model';

export class TerminalVisitorRegistration extends ServiceResponse {

    terminalIdentifier: string;
    name: string;
    firstname: string;
    company: string;
    numberPlate: string;
    reason: string;
    visitedPerson: string;
    needsAreaAccess = false;
    gcCaseId: string;
    gcCaseUrl: string;
    messagingLanguage: string;
    pageCalls = new Array<PageCall>();
    registrationId: number;
    registrationCode: string;
    registrationFinished: number;
    registrationStarted: number;
    smartphoneCommunicationEnabled: boolean;
    smartphoneConnected: boolean;
    smartphoneRequired: boolean;
    inYard: boolean;
    visitorType: number;
    instructionTestResult: boolean;
    instructionTestFailureCount: number;
    sucessfullyFinishedInstructionTests: string;
    instructionsDone: boolean;
    inviteAdditionalVisitorsAllowed: boolean;
    inviterId: number;

    constructor(details?: Partial<TerminalVisitorRegistration>) {
        super(details);
        if (details != null) {
            this.terminalIdentifier = details.terminalIdentifier;
            this.name = details.name;
            this.firstname = details.firstname;
            this.company = details.company;
            this.numberPlate = details.numberPlate;
            this.reason = details.reason;
            this.visitedPerson = details.visitedPerson;
            this.needsAreaAccess = details.needsAreaAccess === true;
            this.gcCaseId = details.gcCaseId;
            this.gcCaseUrl = details.gcCaseUrl;
            this.messagingLanguage = details.messagingLanguage;
            if (details.pageCalls) {
                for (const pageCall of details.pageCalls) {
                    this.pageCalls.push(new PageCall(pageCall));
                }
            }
            this.registrationId = details.registrationId;
            this.registrationCode = details.registrationCode;
            this.registrationFinished = details.registrationFinished;
            this.registrationStarted = details.registrationStarted;
            this.smartphoneCommunicationEnabled = details.smartphoneCommunicationEnabled === true;
            this.smartphoneConnected = details.smartphoneConnected;
            this.smartphoneRequired = details.smartphoneRequired;
            this.inYard = details.inYard === true;
            this.visitorType = details.visitorType;
            this.instructionTestResult = details.instructionTestResult;
            this.instructionTestFailureCount = details.instructionTestFailureCount;
            this.sucessfullyFinishedInstructionTests = details.sucessfullyFinishedInstructionTests;
            this.instructionsDone = details.instructionsDone;
            this.inviteAdditionalVisitorsAllowed = details.inviteAdditionalVisitorsAllowed;
            this.inviterId = details.inviterId;
        }
    }
}

export class TerminalVisitorRegistrationResult extends ServiceResponse {

    registrationId: number;
    name: string;
    firstname: string;
    company: string;
    numberPlate: string;
    visitedPerson: string;
    needsAreaAccess: boolean;
    gatekeeperMandatory: boolean;
    registrationCode: string;
    visitorType: number;
    validity: string;
    inviterId: number;
    informationTexts: Array<string>;

    constructor(details?: Partial<TerminalVisitorRegistrationResult>) {
        super(details);
        if (details != null) {
          this.name = details.name;
          this.firstname = details.firstname;
          this.company = details.company;
          this.numberPlate = details.numberPlate;
          this.visitedPerson = details.visitedPerson;
          this.needsAreaAccess = details.needsAreaAccess === true;
          this.registrationId = details.registrationId;
          this.gatekeeperMandatory = details.gatekeeperMandatory;
          this.registrationCode = details.registrationCode;
          this.visitorType = details.visitorType;
          this.validity = details.validity;
          this.inviterId = details.inviterId;
          this.informationTexts = details.informationTexts;
        }
    }
}


export class VisitorPrintRegistrationCard extends ServiceResponse {
    terminalIdentifier: string;
    lastname: string;
    firstname: string;
    company: string;
    numberPlate: string;
    reason: string;
    visitedPerson: string;
    needsAreaAccess = false;
    visitorType: number;
    registrationQRCode: string;

    constructor(details?: any) {
      super(details);
      if (details != null) {
          this.terminalIdentifier = details.terminalIdentifier;
          this.lastname = details.name;
          this.firstname = details.firstname;
          this.company = details.company;
          this.numberPlate = details.numberPlate;
          this.reason = details.reason;
          this.visitedPerson = details.visitedPerson;
          this.needsAreaAccess = details.needsAreaAccess === true;
          this.visitorType = details.visitorType;
          this.registrationQRCode = details.registrationQRCode;
      }
  }
}
